module.exports = __webpack_public_path__ + "assets/1d3d399c7edc9cf344107a29239260cc.mp3";